/* 22B2 B2B preliminare 2.2.0: server-authorized catalogue prices and draft checkout. */
(() => {
  'use strict';
  // BD_NATIVE_GUARD_230: context comes from Shopify Liquid, never from cart attributes.
  try {
    const node = document.getElementById('BdB2BNativeContext');
    if (!node || JSON.parse(node.textContent).native_b2b !== false) return;
  } catch { return; }

  if (customElements.get('bd-b2b-vat')) return;
  const configNode = document.getElementById('BdB2BConfig');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  try { if (new URL(config.endpoint).protocol !== 'https:') return; } catch { return; }
  const root = (window.Shopify?.routes?.root || config.root || '/').replace(/\/?$/, '/');
  // A B2B code is controlled by the VAT flow. Stop the theme's native coupon
  // handlers before they start removal requests, refresh sections or focus traps.
  // This does not run in Shopify's native checkout.
  function blockB2BRemoval(event) {
    if (event.type === 'keydown' && !['Enter',' ','Spacebar'].includes(event.key)) return;
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const control = target?.closest('[data-remove-code],[data-bd-b2b-remove]');
    if (!control) return;
    const protectedCode = /^B2BV-/i.test(control.dataset.removeCode || '');
    const protectedWidget = control.matches('[data-bd-b2b-remove]') && control.closest('bd-b2b-vat');
    if (!protectedCode && !protectedWidget) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }
  document.addEventListener('click',blockB2BRemoval,true);
  document.addEventListener('keydown',blockB2BRemoval,true);
  const patterns = {
    AT:['U[0-9]{8}',9],BE:['[01][0-9]{9}',10],BG:['[0-9]{9,10}',10],CY:['[0-9]{8}[A-Z]',9],
    CZ:['[0-9]{8,10}',10],DE:['[0-9]{9}',9],DK:['[0-9]{8}',8],EE:['[0-9]{9}',9],EL:['[0-9]{9}',9],
    ES:['[A-Z0-9][0-9]{7}[A-Z0-9]',9],FI:['[0-9]{8}',8],FR:['[A-Z0-9]{2}[0-9]{9}',11],
    HR:['[0-9]{11}',11],HU:['[0-9]{8}',8],IE:['(?:[0-9][A-Z0-9+*][0-9]{5}[A-Z]|[0-9]{7}[A-Z]{1,2})',9],
    IT:['[0-9]{11}',11],LT:['(?:[0-9]{9}|[0-9]{12})',12],LU:['[0-9]{8}',8],LV:['[0-9]{11}',11],
    MT:['[0-9]{8}',8],NL:['[A-Z0-9+*]{12}',12],PL:['[0-9]{10}',10],PT:['[0-9]{9}',9],
    RO:['[0-9]{2,10}',10],SE:['[0-9]{12}',12],SI:['[0-9]{8}',8],SK:['[0-9]{10}',10],
    XI:['(?:[0-9]{9}|[0-9]{12}|GD[0-9]{3}|HA[0-9]{3})',12]
  };
  const normalize = value => value.toUpperCase().replace(/[\s.\-/]+/g, '');
  const prefixFor = values => values.slice(0,2).join('') || 'IT';
  function editValues(values) {
    const prefix = prefixFor(values);
    // Keep an oversized paste invalid instead of silently accepting its first digits.
    state.cellValues = values.slice(0,18);
    const body = state.cellValues.slice(2).join('');
    state.draft = body ? prefix + body : state.cellValues.slice(0,2).join('');
  }
  function validation(value) {
    const vat = normalize(value), prefix = vat.slice(0, 2), body = vat.slice(2), rule = patterns[prefix];
    if (!rule || !(new RegExp(`^(?:${rule[0]})$`)).test(body)) return 'Controlla il prefisso paese e il numero di caratteri.';
    if (prefix === 'IT') {
      if (/^(\d)\1{10}$/.test(body)) return 'La partita IVA italiana non è formalmente valida.';
      let sum = 0;
      for (let i = 0; i < 10; i++) { let n = Number(body[i]); if (i % 2) { n *= 2; if (n > 9) n -= 9; } sum += n; }
      if ((10 - sum % 10) % 10 !== Number(body[10])) return 'La cifra di controllo non è corretta. Controlla la partita IVA.';
    }
    return '';
  }
  function businessError(vat, company, sdi) {
    if (!company.trim() || [...company.trim()].length > 160 || /[\u0000-\u001f\u007f]/.test(company)) return 'Inserisci la ragione sociale (massimo 160 caratteri).';
    if ((!sdi && normalize(vat).startsWith('IT')) || (sdi && !/^[A-Z0-9]{7}$/.test(sdi))) return 'Inserisci un codice SDI di 7 caratteri alfanumerici. È richiesto per le partite IVA italiane.';
    return '';
  }
  function businessComplete(grant) {
    return Boolean(grant && grant.business_fields_version === 1 && grant.profile_complete === true && !businessError(grant.vat,grant.company || '',grant.sdi || ''));
  }
  function businessSaved() {
    const a = state.cart?.attributes || {}, g = state.grant;
    return Boolean(businessComplete(g) && a['Partita IVA B2B'] === g.vat && a['Ragione sociale B2B'] === g.company && (a['Codice SDI B2B'] || '') === (g.sdi || '') && a['Versione dati aziendali B2B'] === '1');
  }
  function editBusiness() {
    if (state.busy || state.reading || state.checkoutBusy) return;
    state.editingBusiness = true;
    if (state.grant) {
      state.draft = state.grant.vat; state.cellValues = [...state.grant.vat];
      state.companyDraft = state.grant.company || ''; state.sdiDraft = state.grant.sdi || '';
    }
    for (const w of widgets()) w.drawCells(state.cellValues);
    show('idle','Aggiorna i dati aziendali e premi Verifica e applica il 50%.');
  }
  const widgets = () => [...document.querySelectorAll('bd-b2b-vat')];
  const state = {companyDraft:'',sdiDraft:'',editingBusiness:false,draft:'', cellValues:[], grant:null, cart:null, cartToken:'', busy:false, message:'', kind:'idle', invalid:false, drawerExpanded:false, timer:null, reading:false, loaded:false, initialSettled:false, lastStatus:0, previousCodes:[], sessionKey:'', quote:null, noEligible:false, checkoutBusy:false, cartFingerprint:''};
  // BD_SESSION_SHARED_231: share only a server credential, never a local VAT approval.
  const sharedSessionName = 'bd_b2b_shared_v231';
  let sessionRevision = 0;
  function storedSharedSession() {
    let raw;
    try {
      raw = localStorage.getItem(sharedSessionName);
    } catch { return {available:false,present:false,value:null}; }
    try { return {available:true,present:raw !== null,value:raw === null ? null : JSON.parse(raw)}; }
    catch { return {available:true,present:true,value:null}; }
  }
  function sessionRead() {
    const shared = storedSharedSession();
    if (shared.present) {
      const value = shared.value;
      if (!value || value.revoked || typeof value.token !== 'string' || !/^[a-f0-9]{64}$/.test(value.key || '') || !(value.expires*1000 > Date.now())) return null;
      return value;
    }
    try { return JSON.parse(sessionStorage.getItem('bd_b2b_v2') || 'null'); } catch { return null; }
  }
  function sessionSave() {
    const valid = state.grant && state.sessionKey && state.grant.expires*1000 > Date.now();
    const shared = storedSharedSession();
    try {
      if (valid) {
        localStorage.setItem(sharedSessionName,JSON.stringify({token:state.cartToken,key:state.sessionKey,expires:state.grant.expires}));
      } else if (shared.value?.token === state.cartToken && !shared.value.revoked) {
        // Keep a tombstone so an older tab cannot revive its legacy credential.
        localStorage.setItem(sharedSessionName,JSON.stringify({token:state.cartToken,revoked:true}));
      }
    } catch { /* Same-tab navigation remains available when shared storage is disabled. */ }
    try {
      if (valid) sessionStorage.setItem('bd_b2b_v2',JSON.stringify({token:state.cartToken,key:state.sessionKey}));
      else sessionStorage.removeItem('bd_b2b_v2');
    } catch { /* Every approval is still checked by the server. */ }
  }
  function safeToken(cart) { return String(cart?.token || '').split('?')[0]; }
  async function jsonFetch(url, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 95000);
    try {
      const response = await fetch(url, {...options, signal:controller.signal, cache:'no-store'});
      const data = await response.json();
      if (!response.ok || data.ok === false) {
        const error = new Error(data.message || data.description || 'Operazione non riuscita. Riprova.');
        error.code = data.error;
        throw error;
      }
      return data;
    } finally { clearTimeout(timer); }
  }
  function api(action, extra = {}) {
    return jsonFetch(config.endpoint, {method:'POST', credentials:'omit', headers:{'Content-Type':'application/json'}, body:JSON.stringify({action, cart_token:state.cartToken, session_key:state.sessionKey, ...extra})});
  }
  function cartData() { return jsonFetch(root + 'cart.js'); }
  function codes(cart) { return (cart?.discount_codes || []).map(x => x.code).filter(Boolean); }
  function eligibility() {
    const ids = new Set((config.eligible || []).map(String)); let gift = String(config.gift || '');
    for (const node of document.querySelectorAll('[data-bd-b2b-price],[data-bd-b2b-product]')) {
      const id = node.dataset.bdB2bPrice || node.dataset.bdB2bProduct;
      if (id) ids.add(id);
    }
    for (const widget of widgets()) {
      try { const data = JSON.parse(widget.querySelector('[data-bd-b2b-state]').textContent); for (const id of data.eligible) ids.add(String(id)); if (data.gift) gift = String(data.gift); } catch { /* No eligibility from a malformed section. */ }
    }
    return {ids, gift};
  }
  const discountLabel = 'Sconto B2B 50%';
  const boundSections = new Set();
  const fallbackMarkup = new WeakMap();
  let presentationFrame = 0, expiryTimer = 0, presentationExpiry = 0, preloadReleased = false;
  function activePricing() {
    return Boolean(businessComplete(state.grant) && state.grant.expires * 1000 > Date.now() && state.cart?.currency === 'EUR');
  }
  function bindVariantSection(sectionId) {
    if (!sectionId || boundSections.has(sectionId)) return;
    boundSections.add(sectionId);
    document.addEventListener('maximize:variant-picker:updated:' + sectionId, event => {
      const freshDocument = typeof event.detail?.updatedHTML === 'string'
        ? new DOMParser().parseFromString(event.detail.updatedHTML, 'text/html') : event.detail?.updatedHTML;
      const freshSources = [...(freshDocument?.querySelectorAll?.('[data-bd-b2b-product]') || [])];
      for (const source of document.querySelectorAll('[data-bd-b2b-product]')) {
        if (source.dataset.sectionId !== sectionId) continue;
        const fresh = freshSources.find(x => x.dataset.sectionId === sectionId);
        if (fresh && event.detail?.currentVariant) source.replaceWith(fresh.cloneNode(true));
        else source.hidden = true; // Unavailable combinations and supplier siblings must not retain an old B2B price.
      }
      queuePresentation();
    });
  }
  function presentation() {
    const active = activePricing();
    const expires = state.grant?.expires || 0;
    if (expires !== presentationExpiry) {
      clearTimeout(expiryTimer); presentationExpiry = expires;
      if (expires) expiryTimer = setTimeout(() => {
        state.grant = null; sessionSave(); show('error','Verifica scaduta. Ripeti la verifica per applicare il 50%.');
      }, Math.max(0, expires * 1000 - Date.now()));
    }
    // Keep the native code in data attributes: Maximize needs it for coupon removal and synchronization.
    for (const label of document.querySelectorAll('[data-discount-title]')) {
      if (/^B2BV-[A-Z0-9]+$/i.test(label.dataset.discountTitle || '') && label.textContent !== discountLabel) label.textContent = discountLabel;
    }
    for (const price of document.querySelectorAll('[data-bd-b2b-price]')) {
      const view = price.querySelector(':scope > [data-bd-b2b-price-view]');
      if (!view) continue;
      price.classList.toggle('bd-b2b-pricing-active',active);
      view.hidden = !active;
    }
    for (const source of document.querySelectorAll('[data-bd-b2b-product]')) {
      bindVariantSection(source.dataset.sectionId);
      const message = source.querySelector('[data-bd-b2b-product-message]');
      if (message) {
        if (!message.dataset.retailText) message.dataset.retailText = message.textContent;
        const text = active ? 'Sconto B2B 50% attivo sui prodotti del Magazzino Italia.' : message.dataset.retailText;
        if (message.textContent !== text) message.textContent = text;
      }
    }
    // Preserve the app block itself: the free-gift widget uses this anchor for its placement.
    for (const block of document.querySelectorAll('div[id*="magic_bundles_magic_bundles_block"]')) {
      const scope = block.closest('product-info');
      const source = scope?.querySelector('[data-bd-b2b-product]');
      const template = source?.querySelector('template[data-bd-b2b-product-price]');
      const enabled = active && source && !source.hidden && Boolean(template?.content.querySelector('[data-bd-b2b-price-view]'));
      let fallback = block.querySelector(':scope > [data-bd-b2b-magic-price]');
      const nativePrice = scope?.querySelector('.product-info__price-wrapper [data-bd-b2b-price-view]');
      if (enabled && !nativePrice) {
        if (!fallback) {
          fallback = document.createElement('div'); fallback.dataset.bdB2bMagicPrice = '';
          fallback.className = 'bd-b2b-magic-price'; block.prepend(fallback);
        }
        if (fallbackMarkup.get(fallback) !== template.innerHTML) {
          fallback.innerHTML = template.innerHTML; fallbackMarkup.set(fallback,template.innerHTML);
        }
        fallback.querySelector('[data-bd-b2b-price-view]').hidden = false;
      }
      if (fallback) fallback.hidden = !enabled || Boolean(nativePrice);
      block.classList.toggle('bd-b2b-magic-active',Boolean(enabled));
    }
    cartPresentation(active);
    document.documentElement.classList.toggle('bd-b2b-draft-active',active);
    // Reveal only after the confirmed price (or the retail fallback) is in the DOM.
    if (!preloadReleased && state.initialSettled && !state.busy) {
      preloadReleased = true;
      document.dispatchEvent(new Event('bd-b2b:ready'));
    }
  }
  function queuePresentation() {
    if (presentationFrame) return;
    presentationFrame = requestAnimationFrame(() => { presentationFrame = 0; presentation(); });
  }
  function paint() { for (const widget of widgets()) widget.paint(); queuePresentation(); }
  function show(kind, message, invalid = false) {
    state.kind = kind; state.message = message; state.invalid = invalid;
    if (kind !== 'idle') state.drawerExpanded = true;
    paint();
  }
  function sectionMap() {
    const mapping = [];
    for (const widget of widgets()) {
      const id = widget.dataset.sectionId;
      if (!id) continue;
      if (widget.dataset.context === 'cart') mapping.push({id, selector:'#MainCart__Items'}, {id, selector:'#MainCart__Summary'});
    }
    const drawer = document.getElementById('CartDrawer');
    if (drawer?.dataset.sectionId) mapping.push({id:drawer.dataset.sectionId, selector:'#CartDrawer'});
    if (document.getElementById('cart-icon-bubble')) mapping.push({id:'cart-icon-bubble', selector:'#cart-icon-bubble'});
    return mapping;
  }
  function replaceSection(existing, fresh) {
    if (existing.id !== 'CartDrawer') { existing.innerHTML = fresh.innerHTML; return; }
    // Shopify returns the closed drawer markup. Keep the current controller/open state:
    // losing is-visible while body overflow remains hidden makes the product page appear frozen.
    const open = existing.hasAttribute('open');
    const scrollPositions = ['.cart-drawer__items__wrapper','.cart-drawer__summary__wrapper'].map(selector =>
      ({selector, top:existing.querySelector(selector)?.scrollTop || 0}));
    existing.innerHTML = fresh.innerHTML;
    if (!open) return; // The customer may have closed it while the request was pending.
    existing.querySelector('#CartDrawer__Wrapper')?.classList.add('is-visible');
    if (existing.hasAttribute('upsell-open')) existing.querySelector('#CartDrawer__Upsell')?.classList.add('is-visible');
    for (const {selector, top} of scrollPositions) {
      const node = existing.querySelector(selector); if (node) node.scrollTop = top;
    }
    requestAnimationFrame(() => {
      if (!existing.isConnected || !existing.hasAttribute('open')) return;
      // Maximize's focus trap caches the first/last buttons; both were replaced above.
      try {
        const focus = window.Alpine?.store?.('xFocusElement');
        if (focus?.trapFocus) focus.trapFocus('CartDrawer__Wrapper','CloseCart');
        else existing.querySelector('#CloseCart')?.focus({preventScroll:true});
      } catch { existing.querySelector('#CloseCart')?.focus({preventScroll:true}); }
    });
  }
  async function updateDiscount(discount, attributes) {
    const mapping = sectionMap();
    const cart = await jsonFetch(root + 'cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({discount, attributes, sections:[...new Set(mapping.map(x => x.id))].slice(0,5), sections_url:location.pathname})});
    let missing = false;
    for (const item of mapping) {
      const text = cart.sections?.[item.id];
      const existing = document.querySelector(item.selector);
      if (!existing) continue;
      if (!text) { missing = true; continue; }
      const fresh = new DOMParser().parseFromString(text, 'text/html').querySelector(item.selector);
      if (fresh) replaceSection(existing,fresh); else missing = true;
    }
    document.cookie = `maximize_discount_code=${codes(cart).filter(code => !/[;\r\n]/.test(code)).join(',')}; path=/; SameSite=Lax; Secure`;
    try {
      const store = window.Alpine?.store('xCouponCodeDetail');
      if (store) store.appliedDiscountCodes = codes(cart);
      window.Alpine?.store('xCartHelper')?.updateCurrentCountItem?.();
    } catch { /* Theme helpers are optional in the isolated preview. */ }
    document.dispatchEvent(new CustomEvent('maximize:cart:discount-code:change', {detail:{source:'bd-b2b'}}));
    state.cart = cart;
    if (missing) {
      // A real page render is safer than showing stale totals when section rendering fails.
      location.reload();
      throw new Error('Aggiornamento del carrello in corso.');
    }
    return cart;
  }
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'it-IT',{style:'currency',currency:state.cart?.currency || 'EUR'}).format(cents/100);
  const textIfChanged = (node,text) => { if (node && node.textContent !== text) node.textContent = text; };
  function fingerprint(cart) { return JSON.stringify([cart.currency,cart.note,cart.attributes,cart.discount_codes,cart.cart_level_discount_applications,cart.items?.map(i=>[i.key,i.variant_id,i.quantity,i.properties,i.original_line_price,i.final_line_price])]); }
  function cartInput(cart) {
    return {currency:cart.currency,note:cart.note,attributes:cart.attributes || {},discount_codes:codes(cart),order_discounts:(cart.cart_level_discount_applications || []).filter(x=>x.target_type==='line_item' && Number(x.total_allocated_amount)>0).map(x=>x.title),items:cart.items.map(i=>({key:i.key,variant_id:String(i.variant_id),quantity:i.quantity,properties:i.properties || {},original_line_price:i.original_line_price,final_line_price:i.final_line_price,selling_plan_allocation:i.selling_plan_allocation,parent_relationship:i.parent_relationship,item_components:i.item_components}))};
  }
  function hideNative(node) { if (node && !node.hasAttribute('data-bd-native-hidden')) node.setAttribute('data-bd-native-hidden',''); }
  function overlay(native,amount,original,slot) {
    if (!native) return;
    hideNative(native);
    let view = native.parentElement.querySelector(':scope > [data-bd-cart-price="'+slot+'"]');
    if (!view) {
      view = document.createElement('span'); view.dataset.bdCartPrice = slot; view.className = 'bd-b2b-cart-price';
      view.innerHTML = '<strong></strong> <s></s>'; native.after(view);
    }
    textIfChanged(view.querySelector('strong'),amount === 0 ? 'GRATIS' : money(amount));
    const old = view.querySelector('s'); textIfChanged(old,money(original)); old.hidden = original <= amount;
  }
  function cartPresentation(active) {
    const ready = active && state.quote && state.cartFingerprint === fingerprint(state.cart);
    const map = new Map(ready ? state.quote.lines.map(l=>[l.key,l]) : []);
    for (const row of document.querySelectorAll('.cart-item__wrapper[data-cart-item-key]')) {
      const line = map.get(row.dataset.cartItemKey);
      const enabled = line && (line.own || line.gift);
      if (!enabled) {
        for (const n of row.querySelectorAll('[data-bd-native-hidden]')) n.removeAttribute('data-bd-native-hidden');
        for (const n of row.querySelectorAll('[data-bd-cart-price],[data-bd-cart-label]')) n.remove();
        continue;
      }
      for (const n of row.querySelectorAll('.cart-item__original-price,.cart-item__original-line-price,.cart-drawer-item__original-price,.cart-item__discount-wrapper,.cart-drawer-item__discounts')) hideNative(n);
      for (const node of row.querySelectorAll('.cart-drawer-item__final-price,.cart-item__final-price')) overlay(node,line.unit,line.original/line.quantity,'unit');
      overlay(row.querySelector('.cart-item__final-line-price'),line.total,line.original,'total');
      for (const container of row.querySelectorAll('.cart-item__price,.cart-drawer-item__price__wrapper')) {
        let label = container.nextElementSibling;
        if (!label?.hasAttribute('data-bd-cart-label')) { label = document.createElement('p'); label.dataset.bdCartLabel = ''; label.className = 'bd-b2b-cart-label'; container.after(label); }
        textIfChanged(label,line.label);
      }
    }
    for (const native of document.querySelectorAll('.main-cart__total-price,.cart-drawer__total > p:last-child')) {
      if (ready) overlay(native,state.quote.subtotal,state.quote.subtotal,'summary');
      else {
        native.removeAttribute('data-bd-native-hidden');
        native.parentElement.querySelector(':scope > [data-bd-cart-price="summary"]')?.remove();
      }
    }
  }
  function queueRead() { clearTimeout(state.timer); state.timer = setTimeout(read, 450); }
  async function completed(result,cart) {
    // Never empty a new/changed cart merely because an old invoice was paid.
    const signature = items => JSON.stringify(items.map(i=>[String(i.variant_id),i.quantity,Object.entries(i.properties || {}).filter(([,v])=>v!=='' && v!==null).sort()]));
    const attributes = {'Partita IVA B2B':'','Ragione sociale B2B':'','Codice SDI B2B':'','Versione dati aziendali B2B':'','Tipo controllo P. IVA':'','Data controllo P. IVA':'','Verifica VIES':'','Riferimento VIES':'','_bd_b2b_mode':'','_bd_b2b_code':''};
    if (result.source && signature(result.source.items) === signature(cart.items)) {
      await jsonFetch(root+'cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'},body:'{}'});
      await jsonFetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes})});
      state.grant = null; state.sessionKey = ''; sessionSave(); location.reload(); return;
    }
    state.cart = await jsonFetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes})});
    state.grant = null; state.sessionKey = ''; state.quote = null; sessionSave();
    show('idle','Acquisto completato. Verifica la partita IVA per un nuovo ordine.');
  }
  async function quote(cart) {
    state.cart = cart; state.quote = null; state.noEligible = false; state.cartFingerprint = '';
    try {
      const result = await api('quote',{cart:cartInput(cart)});
      state.quote = result; state.cartFingerprint = fingerprint(cart);
      show('success','Controllo formale superato. Prezzi B2B attivi sui prodotti del Magazzino Italia.');
    } catch (error) {
      if (error.code === 'no_eligible') {
        state.noEligible = true; show('success','Partita IVA verificata. Il 50% sarà applicato ai prodotti del Magazzino Italia.');
      } else { show('conflict',error.message); throw error; }
    }
  }
  async function read() {
    if (state.busy || state.reading || state.checkoutBusy) return;
    const revision = sessionRevision;
    state.reading = true;
    try {
      const cart = await cartData(); const token = safeToken(cart);
      if (revision !== sessionRevision) return;
      if (token !== state.cartToken) {
        state.grant = null; state.sessionKey = ''; state.quote = null; state.loaded = false; state.lastStatus = 0; state.cartToken = token;
      }
      state.cart = cart;
      const saved = sessionRead();
      if (saved?.token === token && saved.key && (!state.loaded || Date.now()-state.lastStatus > 60000)) {
        state.sessionKey = saved.key;
        const result = await api('status');
        if (revision !== sessionRevision) return;
        state.lastStatus = Date.now();
        if (result.completed) { await completed(result,cart); return; }
        state.grant = result.verified ? result : null;
        if (state.grant && !state.editingBusiness) {
          state.companyDraft = state.grant.company || ''; state.sdiDraft = state.grant.sdi || '';
          state.cellValues = [...state.grant.vat];
          for (const w of widgets()) w.drawCells(state.cellValues);
        }
        if (state.grant) { state.initialSettled = true; show('loading','Aggiornamento dei prezzi del carrello…'); }
        if (!state.grant) { state.sessionKey = ''; show('error','Verifica scaduta. Ripeti il controllo della partita IVA.'); }
      }
      state.loaded = true;
      if (state.grant && state.grant.expires*1000<=Date.now()) { state.grant = null; state.quote = null; show('error','Verifica scaduta. Ripeti il controllo della partita IVA.'); }
      if (state.grant) {
        if (!state.editingBusiness) state.draft = state.grant.vat;
        if (!businessComplete(state.grant)) {
          state.quote = null; show('conflict','Completa ragione sociale e codice SDI per continuare con i prezzi B2B.');
          sessionSave(); return;
        }
        if (!state.quote || state.cartFingerprint!==fingerprint(cart) || state.quote.expires*1000<=Date.now()) await quote(cart);
      }
      sessionSave(); paint();
    } catch (error) { if (state.grant) show('conflict',error.message || 'Non è stato possibile ricontrollare il carrello. Riprova prima di procedere.'); }
    finally { state.reading = false; state.initialSettled = true; if (revision !== sessionRevision) queueRead(); queuePresentation(); }
  }
  async function verify(widget) {
    if (state.busy || state.reading) return;
    state.companyDraft = widget.querySelector('[data-bd-b2b-company-input]')?.value ?? state.companyDraft;
    state.sdiDraft = (widget.querySelector('[data-bd-b2b-sdi-input]')?.value ?? state.sdiDraft).toUpperCase();
    if (widget.dataset.context === 'company') {
      const detailsError = businessError(state.draft,state.companyDraft,state.sdiDraft.trim());
      if (detailsError) {
        show('error',detailsError);
        widget.querySelector(!state.companyDraft.trim() ? '[data-bd-b2b-company-input]' : '[data-bd-b2b-sdi-input]')?.focus(); return;
      }
    }
    const error = validation(state.draft);
    if (error) { show('error',error,true); widget.querySelector('[data-cell="2"]')?.focus(); return; }
    state.busy = true; show('loading','Controllo della partita IVA in corso…');
    const revision = sessionRevision;
    try {
      let before = await cartData();
      // A brand-new empty Shopify cart has a transient token until its first update.
      if (!before.items?.length) before = await jsonFetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:'{}'});
      if (revision !== sessionRevision) throw new Error('La verifica è stata aggiornata in un’altra scheda. Attendi il ripristino.');
      state.cartToken = safeToken(before);
      const company = (widget.querySelector('[data-bd-b2b-company-input]')?.value || state.companyDraft).trim();
      const sdi = (widget.querySelector('[data-bd-b2b-sdi-input]')?.value || state.sdiDraft).trim().toUpperCase();
      const detailsError = businessError(state.draft,company,sdi);
      if (detailsError) throw new Error(detailsError);
      const grant = await api('verify',{vat:normalize(state.draft),company,sdi});
      if (!businessComplete(grant) || grant.company !== company || grant.sdi !== sdi) throw new Error('Il server non ha confermato i dati aziendali. Controlla che l’aggiornamento server 2.1.0 sia installato.');
      if (!grant.verified || !(grant.session_key || state.sessionKey)) throw new Error('Il controllo della partita IVA non è stato completato.');
      if (safeToken(await cartData()) !== state.cartToken) throw new Error('Il carrello è cambiato durante la verifica. Riprova.');
      if (revision !== sessionRevision) throw new Error('La verifica è stata aggiornata in un’altra scheda. Attendi il ripristino.');
      state.companyDraft = grant.company; state.sdiDraft = grant.sdi; state.editingBusiness = false;
      state.grant = grant; state.sessionKey = grant.session_key || state.sessionKey; state.lastStatus = Date.now(); state.loaded = true; sessionSave();
      // Remove only old B2BV codes. Keep unrelated codes visible so the customer can resolve conflicts.
      const otherCodes = codes(before).filter(x=>!/^B2BV-/i.test(x));
      const cart = await updateDiscount(otherCodes.join(','),{'Partita IVA B2B':grant.vat,'Ragione sociale B2B':grant.company,'Codice SDI B2B':grant.sdi,'Versione dati aziendali B2B':'1','Tipo controllo P. IVA':'Formale (checksum), senza consultazione registri','Data controllo P. IVA':grant.checked_at,'_bd_b2b_mode':'draft','_bd_b2b_code':'','Verifica VIES':'','Riferimento VIES':''});
      await quote(cart);
    } catch (error) { show(state.grant ? 'conflict':'error',error.name === 'AbortError' ? 'Il controllo sta impiegando troppo tempo. Riprova tra poco.':error.message,['vat_format','vat_checksum','vat_manual'].includes(error.code)); }
    finally { state.busy = false; state.initialSettled = true; paint(); if (revision !== sessionRevision) queueRead(); }
  }
  function checkoutTarget(event) {
    if (event.type === 'submit') return event.submitter?.matches('[name="checkout"]') || event.target.matches('form[action$="/checkout"]');
    return event.target.closest?.('[name="checkout"],.cart-drawer__checkout,.main-cart__checkout-button,a[href="/checkout"]');
  }
  async function checkout(event) {
    if (!checkoutTarget(event)) return;
    if (!state.initialSettled && sessionRead()?.key) { event.preventDefault(); event.stopImmediatePropagation(); show('loading','Controllo dei prezzi in corso…'); queueRead(); return; }
    if (state.grant && (state.editingBusiness || !businessComplete(state.grant))) {
      event.preventDefault(); event.stopImmediatePropagation();
      show('conflict','Completa i dati aziendali e premi Verifica e applica il 50% prima di procedere.'); return;
    }
    if (!activePricing()) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (state.busy || state.reading || state.checkoutBusy) { show('loading','Attendi l’aggiornamento del carrello.'); return; }
    const button = event.submitter || event.target.closest?.('button,input,a');
    if (button?.disabled) return;
    const form = button?.form || (event.target instanceof HTMLFormElement ? event.target : null);
    if (form && !form.reportValidity()) return;
    const helper = window.Alpine?.store?.('xCartHelper') || window.xCartHelper;
    if (helper?.isUpdating) { show('loading','Attendi l’aggiornamento del carrello.'); return; }
    if (helper?.validateCart) { helper.validateCart(); if (!helper.validated) return; }
    const term = document.querySelector('cart-term');
    if (term && term._isChecked === false) return;
    state.checkoutBusy = true; show('loading','Preparazione del checkout con i prezzi B2B…');
    try {
      const cart = await cartData();
      if (safeToken(cart)!==state.cartToken) throw new Error('Il carrello è cambiato. Ripeti la verifica della partita IVA.');
      if (!state.quote || state.cartFingerprint!==fingerprint(cart)) { await quote(cart); if (state.noEligible) { location.assign(root+'checkout'); return; } show('success','Carrello aggiornato. Controlla i prezzi e premi Cassa per continuare.'); return; }
      const result = await api('checkout',{cart:cartInput(cart),quote_id:state.quote.quote_id});
      if (result.completed) { await completed(result,cart); return; }
      if (result.review_required) { state.quote = result; state.cartFingerprint = fingerprint(cart); show('success','I prezzi sono stati aggiornati. Controlla il carrello e premi Cassa per continuare.'); return; }
      const url = new URL(result.checkout_url);
      const hosts = ['hevj1y-es.myshopify.com','22b2.com','www.22b2.com','checkout.shopify.com','shopify.com'];
      if (url.protocol!=='https:' || !hosts.includes(url.hostname) || url.username || url.password || url.port) throw new Error('Collegamento checkout non verificabile.');
      location.assign(url.href);
    } catch (error) { show('conflict',error.message || 'Non è stato possibile preparare il checkout. Riprova.'); }
    finally { state.checkoutBusy = false; paint(); }
  }
  document.addEventListener('click',checkout,true);
  document.addEventListener('submit',checkout,true);
  class VatWidget extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      const disclosure = this.querySelector('[data-bd-b2b-disclosure]');
      disclosure?.addEventListener('toggle', () => { state.drawerExpanded = disclosure.open; }, options);
      this.addEventListener('click', event => {
        if (event.target.closest('[data-bd-b2b-verify]')) verify(this);
        if (event.target.closest('[data-bd-b2b-edit]')) { event.preventDefault(); editBusiness(); }

      }, options);
      this.addEventListener('input', event => {
        if (event.target.matches('[data-bd-b2b-company-input],[data-bd-b2b-sdi-input]')) {
          const company = event.target.matches('[data-bd-b2b-company-input]');
          if (company) state.companyDraft = event.target.value;
          else state.sdiDraft = event.target.value.toUpperCase();
          if (state.grant) state.editingBusiness = true;
          state.kind = 'idle'; state.message = ''; paint(); return;
        }
        if (!event.target.matches('[data-cell]')) return;
        let index = Number(event.target.dataset.cell);
        const value = event.target.value.toUpperCase().replace(/[^A-Z0-9+*]/g,'').slice(-1);
        const chars = [...this.querySelectorAll('[data-cell]')].map(x => x.value.toUpperCase());
        // A number typed over the I/T hint starts the Italian number, not the country code.
        if (index < 2 && /^\d$/.test(value) && chars.slice(0,2).every((x,i) => i === index || !x)) {
          chars[index] = '';
          const empty = chars.findIndex((x,i) => i >= 2 && !x);
          index = empty < 0 ? 2 : empty;
        }
        chars[index] = value;
        // Keep empty intermediate cells in the editor, rather than shifting later characters left.
        editValues(chars);
        state.kind = 'idle'; state.message = ''; state.invalid = false;
        for (const w of widgets()) w.drawCells(state.cellValues);
        paint();
        if (value) this.querySelector(`[data-cell="${index+1}"]`)?.focus();
        const complete = validation(state.draft);
        const hasBody = state.cellValues.slice(2).filter(Boolean).length;
        if (hasBody >= ((patterns[prefixFor(state.cellValues)] || [null,11])[1])) show(complete ? 'error' : 'idle', complete || 'Formato corretto. Premi il pulsante per completare il controllo.',Boolean(complete));
      }, options);
      this.addEventListener('paste', event => {
        if (!event.target.matches('[data-cell]')) return;
        const pasted = normalize(event.clipboardData.getData('text')).replace(/[^A-Z0-9+*]/g,'');
        if (!pasted) return;
        event.preventDefault(); // Paste is distributed across cells, never blocked.
        const explicitPrefix = /^[A-Z]{2}/.test(pasted);
        const currentPrefix = [...this.querySelectorAll('[data-cell]')].slice(0,2).map(x => x.value);
        const values = explicitPrefix ? [...pasted] : [...currentPrefix,...pasted];
        editValues(values);
        for (const w of widgets()) w.drawCells(state.cellValues);
        const err = validation(state.draft); show(err ? 'error':'idle',err || 'Formato corretto. Premi il pulsante per completare il controllo.',Boolean(err));
        this.querySelector(`[data-cell="${Math.min(values.length, this.cellCount()-1)}"]`)?.focus();
      }, options);
      this.addEventListener('keydown', event => {
        if (this.dataset.context === 'company' && event.key === 'Enter' && event.target.matches('[data-bd-b2b-company-input],[data-bd-b2b-sdi-input]')) {
          event.preventDefault(); verify(this); return;
        }
        if (!event.target.matches('[data-cell]')) return;
        const index = Number(event.target.dataset.cell);
        if (event.key === 'Enter') { event.preventDefault(); verify(this); }
        if (event.key === 'ArrowLeft' || (event.key === 'Backspace' && !event.target.value)) { event.preventDefault(); this.querySelector(`[data-cell="${Math.max(0,index-1)}"]`)?.focus(); }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.querySelector(`[data-cell="${index+1}"]`)?.focus(); }
      }, options);
      this.addEventListener('focusin', event => { if (event.target.matches('[data-cell]')) event.target.select(); }, options);
      this.drawCells(state.cellValues); this.paint(); queueRead();
    }
    disconnectedCallback() { this.abort?.abort(); }
    prefix() { return prefixFor([...this.querySelectorAll('[data-cell]')].map(x => x.value)); }
    cellCount() { return 2 + (patterns[this.prefix()] || [null,11])[1]; }
    drawCells(values) {
      const box = this.querySelector('[data-bd-b2b-cells]');
      const prefix = prefixFor(values);
      const count = 2 + (patterns[prefix] || [null,11])[1];
      const selected = this.contains(document.activeElement) ? Number(document.activeElement.dataset.cell) : null;
      let cells = [...box.querySelectorAll('[data-cell]')];
      if (cells.length !== count) {
        box.replaceChildren(...Array.from({length:count}, (_,i) => {
          const input = document.createElement('input');
          input.type = 'text'; input.className = 'bd-b2b__cell'; input.dataset.cell = String(i); input.maxLength = 1;
          input.autocomplete = 'off'; input.spellcheck = false;
          input.setAttribute('aria-label',`Carattere ${i+1} della partita IVA`);
          input.setAttribute('aria-describedby',this.querySelector('[data-bd-b2b-message]').id);
          return input;
        }));
        cells = [...box.querySelectorAll('[data-cell]')];
      }
      box.style.setProperty('--bd-b2b-cells',String(count));
      cells.forEach((cell,i) => {
        cell.value = values[i] || ''; cell.placeholder = i === 0 ? 'I' : i === 1 ? 'T' : '';
        cell.inputMode = i < 2 || prefix !== 'IT' ? 'text' : 'numeric';
      });
      if (selected !== null) this.querySelector(`[data-cell="${selected}"]`)?.focus();
    }
    paint() {
      this.dataset.state = state.kind;
      this.setAttribute('aria-busy',String(state.busy || state.checkoutBusy));
      const disclosure = this.querySelector('[data-bd-b2b-disclosure]');
      if (disclosure && state.drawerExpanded) disclosure.open = true;
      const companyPage = this.dataset.context === 'company';
      const saved = businessSaved();
      const active = businessComplete(state.grant) && !state.editingBusiness && (!companyPage || saved);
      const companyInput = this.querySelector('[data-bd-b2b-company-input]');
      const sdiInput = this.querySelector('[data-bd-b2b-sdi-input]');
      if (companyInput && companyInput.value !== state.companyDraft) companyInput.value = state.companyDraft;
      if (sdiInput && sdiInput.value !== state.sdiDraft) sdiInput.value = state.sdiDraft;
      for (const input of [companyInput,sdiInput]) if (input) input.disabled = state.busy || state.checkoutBusy;
      this.querySelector('[data-bd-b2b-fields]').hidden = active;
      this.querySelector('[data-bd-b2b-verified]').hidden = !active;
      for (const button of this.querySelectorAll('button')) button.disabled = state.busy || state.checkoutBusy;
      for (const cell of this.querySelectorAll('[data-cell]')) { cell.disabled = state.busy; cell.setAttribute('aria-invalid',String(state.invalid)); }
      this.querySelector('[data-bd-b2b-verify]').textContent = state.busy ? 'Verifica in corso…' : (companyPage ? 'Verifica e salva i dati' : 'Verifica e applica il 50%');
      this.querySelector('[data-bd-b2b-message]').textContent = companyPage && active && state.kind === 'success' ? 'Dati aziendali salvati per questo acquisto. Puoi tornare al carrello.' : state.message || 'Inserisci i dati aziendali, poi avvia la verifica.';
      for (const [selector,value] of [['[data-bd-business-name]',state.grant?.company],['[data-bd-business-vat]',state.grant?.vat],['[data-bd-business-sdi]',state.grant?.sdi || 'Non indicato']]) {
        const node = this.querySelector(selector); if (node) node.textContent = active ? value || '' : '';
      }
      this.querySelector('[data-bd-b2b-company]').textContent = active ? [state.grant.company, state.grant.vat, state.grant.sdi ? 'SDI: ' + state.grant.sdi : ''].filter(Boolean).join(' · ') : '';
    }
  }
  customElements.define('bd-b2b-vat',VatWidget);
  window.addEventListener('beforeunload', event => {
    if (!widgets().some(w => w.dataset.context === 'company')) return;
    const typed = state.companyDraft.trim() || state.sdiDraft.trim() || state.cellValues.some(Boolean);
    const unchanged = businessSaved() && normalize(state.draft) === state.grant.vat && state.companyDraft.trim() === state.grant.company && state.sdiDraft.trim().toUpperCase() === (state.grant.sdi || '');
    if (typed && !unchanged) { event.preventDefault(); event.returnValue = ''; }
  });
  // Prices and app blocks can also arrive through quick view, filtering and recommendations.
  new MutationObserver(queuePresentation).observe(document.body,{childList:true,subtree:true});
  queuePresentation(); queueRead();
  for (const name of ['maximize:cart:updated','maximize:cart:discount-code:change','cart:minicart:open']) document.addEventListener(name, queueRead);
  window.addEventListener('storage', event => {
    if (event.key !== sharedSessionName && event.key !== null) return;
    sessionRevision++;
    state.grant = null; state.sessionKey = ''; state.quote = null;
    state.loaded = false; state.lastStatus = 0; state.initialSettled = false;
    try { sessionStorage.removeItem('bd_b2b_v2'); } catch { /* Optional browser storage. */ }
    let value = null;
    try { value = event.newValue ? JSON.parse(event.newValue) : null; } catch { /* Invalid data never authorizes prices. */ }
    if (value?.native === true) { location.reload(); return; }
    if (!state.busy && !state.checkoutBusy) {
      show('idle',value && !value.revoked ? 'Ripristino della verifica B2B…' : 'Verifica B2B aggiornata in un’altra scheda.');
    }
    queuePresentation(); queueRead();
  });
  document.addEventListener('visibilitychange',() => { if (!document.hidden) { state.lastStatus = 0; queueRead(); } });
  window.addEventListener('pageshow',() => { state.lastStatus = 0; queueRead(); });
  setInterval(() => { if (state.grant && !document.hidden) queueRead(); },60000);
})();
